module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>';
 if (isOasisFile) { 
__p+='<input type="checkbox" class="float-right"/>';
 } 
__p+='</td>\r\n<td><a href="/#document/'+
((__t=( id ))==null?'':__t)+
'" target="_blank">'+
((__t=( name ))==null?'':__t)+
'</a></td>\r\n<td>'+
((__t=( fmCreatedTime ))==null?'':__t)+
'</td>\r\n<td>\r\n    <a href="/api/document/download/'+
((__t=( id ))==null?'':__t)+
'" class="preview-doc" style="color:'+
((__t=( color ))==null?'':__t)+
';"><span class="clickable glyphicon glyphicon-floppy-disk"/></a>\r\n</td>\r\n<td>\r\n    <a href="/api/document/view/'+
((__t=( id ))==null?'':__t)+
'" target="_blank" class="preview-doc" style="color:'+
((__t=( color ))==null?'':__t)+
';"><span class="clickable glyphicon glyphicon-eye-open"/></a>\r\n</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/medicals/patient-documents-row.html
// module id = 368
// module chunks = 0